import { fetchJson } from '@helpCenter/util/fetch/fetch';
import { v4 } from 'uuid';
import { doc, p } from '@atlaskit/adf-utils/builders';
import { getMeta } from '@atlassian/help-center-common-util/meta';
import type { Message } from '../../common/types';
import type { CreateVirtualAgentConversationResponse, VirtualAgentConversationMessageResponse } from './types';

export const useVirtualAgentConversationProvider = () => {
    const startConversation = async (): Promise<CreateVirtualAgentConversationResponse> => {
        const cloudId = getMeta('tenant-id') ?? undefined;

        if (!cloudId) {
            return Promise.reject(new Error('No cloud id'));
        }

        const response = await fetchJson<CreateVirtualAgentConversationResponse>(
            `/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/web/conversation`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jiraProjectId: '10000', // TODO when we move to portal we will fetch project id from url
                    createdAt: new Date().toISOString(),
                }),
                method: 'POST',
            }
        );
        return response;
    };

    const sendMessage = async (message: string, conversationId: string): Promise<Message[]> => {
        const cloudId = getMeta('tenant-id') ?? undefined;

        if (!cloudId) {
            return Promise.reject(new Error('No cloud id'));
        }

        const response = await fetchJson<VirtualAgentConversationMessageResponse[]>(
            `/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/web/conversation/message`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: v4(),
                    conversationChannelId: conversationId,
                    createdAt: new Date().toISOString(),
                    content: JSON.stringify(doc(p(message))),
                }),
                method: 'POST',
            }
        );

        return response.map((agentMessage) => ({ ...agentMessage, type: 'Agent' }));
    };

    return { startConversation, sendMessage };
};
